import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Sprout } from 'lucide-react';
import { api, fileUrl } from '@/lib/api';

export default function PartnerFarms() {
  const [farms, setFarms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/partner-farms').then((r) => setFarms(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-20 min-h-screen bg-cream" data-testid="partner-farms-page">
      <section className="container-custom py-16">
        <span className="badge-local">Our Partners</span>
        <h1 className="font-playfair text-4xl md:text-6xl font-bold text-dark tracking-tight mt-5">Meet Our Farm Partners</h1>
        <p className="font-manrope text-lg text-dark/60 mt-4 max-w-2xl">The local New Hampshire farms and producers behind every FarmBox.</p>

        {loading ? (
          <div className="flex justify-center py-24"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-forest" /></div>
        ) : farms.length === 0 ? (
          <div className="text-center py-24">
            <Sprout className="w-16 h-16 text-dark/20 mx-auto mb-4" />
            <h3 className="font-playfair text-2xl font-bold text-dark mb-2">Farm partners coming soon</h3>
            <p className="font-manrope text-dark/60">Are you a local producer? <Link to="/for-farms" className="text-forest font-medium hover:underline">Partner with FarmBox</Link>.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
            {farms.map((f) => (
              <Link key={f.farm_id} to={`/partner-farms/${f.farm_id}`} className="group bg-white rounded-3xl overflow-hidden border border-brown/10 shadow-card hover:shadow-hover transition-shadow duration-500" data-testid={`partner-farm-${f.farm_id}`}>
                <div className="h-48 bg-forest/10 overflow-hidden">
                  <img src={fileUrl(f.cover_file_id) || 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800'} alt={f.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <h3 className="font-playfair text-2xl font-bold text-dark">{f.name}</h3>
                  {f.town && <p className="flex items-center gap-1.5 text-dark/60 font-manrope text-sm mt-1"><MapPin className="w-4 h-4 text-gold" />{f.town}, NH</p>}
                  <p className="font-manrope text-dark/60 mt-3 line-clamp-2">{f.story}</p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    {f.products.slice(0, 4).map((p) => <span key={p} className="badge-organic">{p}</span>)}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
